import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { computed } from "mobx";

export class SupplierListDataService extends DataService<typeof Model.Products.Logic.ViewModels.SupplierSummary, Model.Products.Logic.ViewModels.SupplierSummary, SupplierSummary> {
    protected map(entity: Model.Products.Logic.ViewModels.SupplierSummary): SupplierSummary {
        return new SupplierSummaryModel(entity);
    }


    public static make(ctx?: any): SupplierListDataService {
        return new SupplierListDataService(ctx, ctx=>ctx.SupplierSummaries);
    }
}

export class SupplierSummaryModel extends EntityModel<Model.Products.Logic.ViewModels.SupplierSummary, SupplierSummary> implements SupplierSummary {

    @property<SupplierSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<SupplierSummaryModel>(o => o.entity.supplierNumber, (o, value) => o.entity.supplierNumber = value)
    public supplierNumber: string;

    @property<SupplierSummaryModel>(o => o.entity.title, (o, value) => o.entity.title = value)
    public title: string;

    @property<SupplierSummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
    public type: Model.Products.Domain.Models.SupplierType;

    @property<SupplierSummaryModel>(o => o.entity.defaultCurrencyId, (o, value) => o.entity.defaultCurrencyId = value)
    public defaultCurrencyId: number;

    @computed public get typeText(): string {
        switch (this.entity.type) {
            case 0:
                return 'General';
            case 1:
                return 'CarRent';

        }
        return null;
    }

    @property<SupplierSummaryModel>(o => o.entity.defaultMargin, (o, value) => o.entity.defaultMargin = value)
    public defaultMargin: number;
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/list/supplier-list.data.ts